import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { Contact } from "@/components/Contact";
import { RelatedLinks } from "@/components/RelatedLinks";
import { usePageMeta } from "@/hooks/usePageMeta";
import { SITE } from "@/data/site";

export default function ContactPage() {
  usePageMeta(
    "Contact",
    "Get in touch with USDD Academy — classes, kids enrolment, online courses, bookings and bespoke workshops. London, Kent, Medway, Chatham, Elephant & Castle."
  );
  return (
    <>
      <Header />
      <main>
        <PageHero
          overline="07 · Get in touch"
          title="Let's"
          highlight="move."
          description="Whether you're joining a class, enrolling a child, enquiring about online courses or booking a bespoke workshop — our team replies within 24 hours."
          ctaPrimary={{ label: "Send Message", to: "/contact#contact" }}
          ctaSecondary={{ label: "See programmes", to: "/journey" }}
          bg={SITE.hero}
        />
        <Contact />
        <RelatedLinks
          title="While you're here"
          items={[
            { tag: "Adults", label: "Weekly Training", desc: "London & Kent classes", to: "/training" },
            { tag: "Kids", label: "USDD Kids", desc: "Ages 6–17 programme", to: "/kids" },
            { tag: "B2B", label: "Bookings", desc: "Schools, brands, festivals", to: "/bookings" },
          ]}
        />
      </main>
      <Footer />
    </>
  );
}
